export default __webpack_public_path__ + "static/media/Laptop.2e365964.svg";